import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()((theme) => {
    return {
        buttonContainer: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 120,
        },
        button: {
            cursor: 'pointer',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: theme.typography.body1.fontSize,
            fontFamily: theme.typography.fontFamily,
            height: 36,
            fontWeight: theme.typography.body1.fontWeight,
            letterSpacing: 1.25,
            borderRadius: 4,
            padding: `0px ${theme.spacing(0.5)}`,
            boxSizing: 'border-box',
        },
        buttonPrimary: {
            background: theme.palette.primary.main,
            boxShadow: `0px 1px 3px ${theme.palette.secondary[400]}`,
            color: theme.palette.common.white,
        },
        buttonSecondary: {
            background: theme.palette.common.white,
            border: `1px solid ${theme.palette.primary.main}`,
            color: theme.palette.primary.main,
        },
        buttonAlert: {
            background: theme.palette.common.red,
            border: `1px solid ${theme.palette.common.red}`,
            color: theme.palette.common.white,
        },
        buttonDisabledPrimary: {
            background: theme.palette.secondary[400],
        },
        buttonDisabledSecondary: {
            border: `1px solid ${theme.palette.secondary[400]}`,
            color: theme.palette.secondary[400],
        },
        buttonLoading: {
            opacity: 0.5,
        },
        buttonTitle: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.button.fontSize,
            fontWeight: theme.typography.button.fontWeight,
            letterSpacing: theme.typography.button.letterSpacing,
            textAlign: 'center',
        },
        buttonTitleUppercase: {
            textTransform: 'uppercase',
        },
    }
})

export default useStyles
